import { QueryClient } from '@tanstack/react-query';

/**
 * queryClient — Shared TanStack Query client instance.
 *
 * Cache strategy:
 *   - staleTime: 5 min for domain data (members, finance, units)
 *   - gcTime:    30 min — keep evicted data in memory for instant back-navigation
 *   - retry:     2 automatic retries on failure before showing error state
 *
 * Lookup-specific overrides (genders, roles, etc.) use 24h staleTime
 * because they are managed by the backend Caffeine cache with daily refresh.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,    // 5 min — most domain data
      gcTime: 30 * 60 * 1000,       // 30 min — keep in memory post-unmount
      retry: 2,
      refetchOnWindowFocus: false,  // Don't refetch on tab switch (uses staleTime)
      refetchOnMount: true,
    },
    mutations: {
      retry: 0,                     // Mutations must not auto-retry (side-effect safety)
    },
  },
});

/** staleTime override for lookup data (cached 24h on backend) */
export const LOOKUP_STALE_TIME = 24 * 60 * 60 * 1000; // 24h

/** staleTime override for finance/transaction data (user expects fresh data) */
export const FINANCE_STALE_TIME = 60 * 1000; // 1 min
